<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space">{{ msgAlerta }}</div>

    <div v-show="((!modoEdicao) && (!modoView))">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><RangeDataSelect :periodoInicial="'currentYear'" v-model="dateRange" /></div>

            <div class="form-item">
                <div v-if="globalStore.ckperfilestabelecimento || globalStore.ckperfilrt">
                    <label class="label-caption">Estabelecimento</label>
                    <div class="field-label">{{ globalStore.nmestabelecimento }}</div>
                </div>
                <div v-else>
                    <EstabelecimentoSelect v-model:idSelecionado="estabelecimentoSelecionado" />
                </div>
            </div>

            <PlaMelStatusSelect v-if="showStatusSelect" :ckAddTodos="true" v-model:opcaoSelecionada="statusSelecionado" />
            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button v-if="globalStore.ckperfilestabelecimento || globalStore.ckperfilrt" type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>
        
        <div v-if="lsDados.length > 0" class="table-wrapper">
            <table>
                <thead><tr>
                    <th class="col-width-char10">Ano/Mês</th>
                    <th class="col-width-char20">Protocolo</th>
                    <th class="col-width-char10">Digitação</th>
                    <th>Estabelecimento</th>
                    <th class="col-width-char20">Situação</th>
                    <th class="col-width-char15">Quantidade</th>
                </tr></thead>

                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.idregistro" @click="onClickItem(obj)"
                    :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                        <td class="col-width-char10 center">{{ obj.anomes }}</td>
                        <td class="col-width-char20">{{ obj.protocolo }}</td>
                        <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dhdigitacao) }}</td>
                        <td>{{ obj.nmestabelecimento }}</td>
                        <td class="col-width-char20">{{ obj.nmstatus }}</td>
                        <td class="col-width-char15 right">{{ Funcoes.formatDecimal(obj.qtd_total) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>



        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-if="modoEdicao">
        <PlaMelEditPage :idEdicao="idEdicao" @close="modoEdicao = false" @salvo="lerDados" />
    </div>


    <div v-if="modoView">
        <PlaMelViewPage :idView="idView" @close="modoView = false" @salvo="lerDados" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { Funcoes } from '@/funcoes/funcoes';
import { genericPost } from '@/funcoes/api';
import { globalStore } from '@/globals';
import EstabelecimentoSelect from '@/components/selects/EstabelecimentoSelect.vue';
import PlaMelEditPage from '../formularios/PlaMelEditPage.vue';
import PlaMelStatusSelect from '@/selects/estaticos/PlaMelStatusSelect.vue';
import PlaMelViewPage from '../visualizacoes/PlaMelViewPage.vue';
import RangeDataSelect from '@/components/selects/RangeDataSelect.vue';

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const emit = defineEmits(['close']);
const estabelecimentoSelecionado = ref(null);
const idEdicao = ref(null);
const idView = ref(null);
const isLoading = ref(false);
const lsDados = ref([]);
const modoEdicao = ref(false);
const modoView = ref(false);
const msgAlerta = ref(null);
const showStatusSelect = ref(((globalStore.ckperfilestabelecimento) || (globalStore.ckperfilrt)));
const statusSelecionado = ref(0);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);

const closeForm = () => {emit('close');}

const lerDados = async() => {
    try{
        Funcoes.validarIntervaloDatas(dateRange.value.startDate, dateRange.value.endDate);
        msgAlerta.value = null;
        isLoading.value = true;
        const dados = {
            idep: globalStore.idep,
            idsim: globalStore.idsim,
            idestabelecimento: ((globalStore.ckperfilestabelecimento) || (globalStore.ckperfilrt)) ? globalStore.idestabelecimento : estabelecimentoSelecionado.value,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            intparam1: (showStatusSelect.value) ? statusSelecionado.value : 5,
            intparam2: (showStatusSelect.value) ? 0 : 9};  // SELECIONAR CANCELADOS AUTOMÁTICO QUANDO FOR PERFIL FISCAL OU SUPERVISOR
        const req = await genericPost('/lspla/plamel', dados);
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}

const novoCadastro = () => {
    idEdicao.value = 0;
    modoEdicao.value = true;
}

function onClickItem(obj){
    if (obj.idstatus==1  && (globalStore.ckperfilestabelecimento || globalStore.ckperfilrt)){
        idEdicao.value=obj.id;
        modoEdicao.value=true;
    }
    else{
        idView.value=obj.id;
        modoView.value=true;
    }
}

const updatePaginatedData = () => {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}

onMounted(lerDados);
</script>